import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { clearQueryCacheNamespace } from 'hooks/useQuery';
import { normalizePathname } from 'utilities/normalizePathname';
import { LINKED_RECORDS_CACHE_KEY_PREFIX } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/LinkedRecordsTab/hooks/useLinkedRecords';

/**
 * Linked Records are cached in memory for as long as the route stays the
 * same (see useLinkedRecords), so switching between work orders, tabs, or
 * pages never refetches something already loaded. That cache is cleared as
 * soon as the route itself changes, so navigating elsewhere and back never
 * serves what could by then be stale data.
 */
const useEvictLinkedRecordsCacheOnNavigation = () => {
  const { pathname } = useLocation();
  const currentPath = normalizePathname(pathname);
  const previousPathRef = useRef(currentPath);

  useLayoutEffect(() => {
    if (previousPathRef.current !== currentPath) {
      clearQueryCacheNamespace(LINKED_RECORDS_CACHE_KEY_PREFIX);
      previousPathRef.current = currentPath;
    }
  }, [currentPath]);
};

export default useEvictLinkedRecordsCacheOnNavigation;
